module.exports = __webpack_public_path__ + "img/modulo_Imagen.202b495.svg";